(function () {
    'use strict';

    // @ngInject
    function WebsocketHelperServiceCtor($q, $rootScope, websocket, AppConfigService, $http, Gon, Constants, RepositoryService, AnalyticsService, PubSubService, Fingerprint, $injector) {

        this.websocket = websocket;
        this.$q = $q;
        this.AppConfigService = AppConfigService;
        this.$http = $http;
        this.Gon = Gon;
        this.RepositoryService = RepositoryService;
        this.$injector = $injector;
        this.Constants = Constants;
        this.registeredRooms2 = [];
        this.waitingToSocketRooms2 = [];
        this.AnalyticsService = AnalyticsService;
        this.$rootScope = $rootScope;
        this.Fingerprint = Fingerprint;
        this.websocket2Authenticated = false;
        this.websocket2 = null;

        PubSubService.ventMyBitchUp(this);
    }

    Services.WebsocketHelperService = Class({
        constructor: WebsocketHelperServiceCtor,

        connect: function connect() {
            var self = this;


            var secureConn = self.Gon.environment !== 'development' ? true : false;
            var isConnectionRetry = this.Gon.web_socket_conn_retry === "true";
            var socket_environment = self.Gon.web_socket_environment; // TBD - Currently not used. For prod we have one prod env using prod moshe

            if (this.Gon.websocket_address_2) {
                self.websocket2 = this.websocket.connect(this.Gon.websocket_address_2, {
                    secure: secureConn,
                    reconnection: isConnectionRetry,
                    reconnectionDelay: 5000,
                    reconnectionDelayMax: 60000
                });

                self.websocket2.on('connect', function () {

                    var token = self.RepositoryService.storageGet(self.Constants.storage.AUTH_TOKEN);
                    var userId = self.RepositoryService.storageGet(self.Constants.storage.AUTH_USER_ID);
                    var apiVersion = self.Gon.api_version;
                    self.Fingerprint().then(function (fingerprint) {
                        self.websocket2.emit('authentication', {
                            token: token,
                            user_id: userId,
                            api_version: apiVersion,
                            fingerprint: fingerprint
                        });
                    });
                    self.websocket2.on('authenticated', function () {
                        self.websocket2Authenticated = true;
                        self.trigger('websocket_connected');

                        for (var i = self.waitingToSocketRooms2.length - 1; i >= 0; i--) {
                            var entry = self.waitingToSocketRooms2[i];
                            self.registerToRoom(entry.id, entry.callback);
                            self.waitingToSocketRooms2.splice(i, 1);
                        }
                    });
                    self.websocket2.on('unauthorized', function () {
                        var UsersManager = self.$injector.get('UsersManager');
                        UsersManager.forceFetchCurrUser();
                    });
                });

                self.websocket2.on('disconnect', function () {
                    self.trigger('websocket_disconnected');
                    self.websocket2Authenticated = false;
                    for (var i = self.registeredRooms2.length - 1; i >= 0; i--) {
                        var entry = self.registeredRooms2[i];

                        if (self.waitingToSocketRooms2.map(function (x) {
                            return x.id;
                        }).indexOf(entry.id) === -1) {
                            self.waitingToSocketRooms2.push({
                                id: entry.id,
                                callback: entry.callback
                            });
                        }
                        self.registeredRooms2.splice(i, 1);
                        self.websocket2.off(entry.id);
                    }
                    if (self.websocket2.io.connecting.length === 0 && self.RepositoryService.storageGet(self.Constants.storage.AUTH_USER_ID)) {
                        self.websocket2.connect();
                    }
                });
            }
        },

        disconnect: function disconnect() {
            var self = this;

            if (self.websocket2 && self.websocket2.connected) {
                self.websocket2.disconnect();
            }
        },

        isConnected: function isConnected() {
            return this.websocket2 && this.websocket2.connected;
        },

        registerToRoom: function registerToRoom(object_id, callback) {
            var self = this;

            if (self.websocket2 && self.websocket2.connected && self.websocket2Authenticated) {
                //don't register already to already registered rooms
                var position2 = this.registeredRooms2.map(function (x) {
                    return x.id;
                }).indexOf(object_id);
                if (position2 === -1) {
                    console.log("Registering to: "+ object_id);
                    self.websocket2.emit('register', {room: object_id});
                    self.websocket2.on(object_id, function () {
                        var args = Array.prototype.slice.call(arguments, 0); // arguments is not a native Array so we need to call slice in a funky way
                        this.$rootScope.$applyAsync(function asyncCall() {
                            callback.apply(callback, args);
                        });
                    }.bind(this));
                    self.registeredRooms2.push({id: object_id, callback: callback});
                }
            } else {
                // Add to waiting list
                if (self.waitingToSocketRooms2.map(function (x) {
                    return x.id;
                }).indexOf(object_id) === -1) {
                    self.waitingToSocketRooms2.push({id: object_id, callback: callback});
                }
            }
        },

        unregisterFromRoom: function unregisterFromRoom(object_id) {
            var self = this;

            if (self.websocket2 && self.websocket2.connected && self.websocket2Authenticated) {
                self.websocket2.emit('unregister', {room: object_id});
                self.websocket2.off(object_id);

                var position2 = this.registeredRooms2.map(function (x) {
                    return x.id;
                }).indexOf(object_id);
                if (position2 > -1) {
                    this.registeredRooms2.splice(position2, 1);
                }
            }
        },

    });

}());
